"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./FieldLabel.scss");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const FieldLabel = ({
  label
}) => {
  return _react.default.createElement("div", {
    className: "admin-field__label"
  }, label);
};
/*

class FieldLabel extends Component {

    static defaultProps = {
        id: "",
        label: "",
        language: false,
        required: false,
        collapsible: false,
        expanded: true
    }
    
    render() {
        const { id, label, summary, collapsible, expanded, language, toggleUrl } = this.props;

        if (typeof label !== "string") {
            return false;
        }

        if (!label) {
            return false;
        }

        if (collapsible && language) {
            return (
                <div className="admin-field__label  label--toggle" lang={language} aria-expanded={expanded} onClick={this.onToggle}>
                    <span className="label__toggle">{label} <i className="label__summary">{summary}</i></span>
                </div>
            )
        }

        if (collapsible) {
            return (
                <div className="admin-field__label  label--toggle" aria-expanded={expanded} onClick={this.onToggle}>
                    <span className="label__toggle">{label} <i className="label__summary">{summary}</i></span>
                </div>
            )
        }
        
        if (language) {

            return (
                <label className="admin-field__label" htmlFor={id} lang={language}>{label} <i className="label__summary">{summary}</i></label>
            )
            
        }

        return (
            <label className="admin-field__label" htmlFor={id}>{label} <i className="label__summary">{summary}</i></label>
        )
    }
}


*/


var _default = FieldLabel;
exports.default = _default;
module.exports = exports.default;